export class FeatureIntroductionPagePresenter {
    constructor(page) {
        this.title = page.title;
        this.message = page.message;
        this.imageFile = page.imageFile;
    }
}